import { getRandom } from "../../functions/Common";
import { Deck, DeckState } from "../../models/Deck";
import { tournamentFormatCardLimitMap } from "../../models/TournamentFormat";
import { UserSettings } from "../../models/UserSettings";

export function convertDeckStateToDeck(
    deckState: DeckState,
    userSettings?: UserSettings,
    includeNonEditableFields?: boolean
): Deck {
    let profileVariantId: string = deckState.editableFields.unsaved.profileVariantId;
    if (!profileVariantId) {
        profileVariantId = getRandom(Object.keys(deckState.editableFields.unsaved.totalCardsByVariant)) ?? "";
    }

    let isValidDeck = false;
    const formatRules = tournamentFormatCardLimitMap[deckState.editableFields.unsaved.format];

    if (formatRules) {
        let isMinValid = false;
        let isMaxValid = false;

        isMinValid = deckState.totalCards >= formatRules.min;

        isMaxValid = formatRules.max === -1
            ? deckState.totalCards >= formatRules.min
            : deckState.totalCards <= formatRules.max;

        isValidDeck = isMinValid && isMaxValid;
    }

    const deck: Deck = {
        id: deckState.nonEditableFields.id,
        elementCount: deckState.nonEditableFields.elements,
        displayName: userSettings ? userSettings.displayName : "",
        isPublic: deckState.editableFields.unsaved.isPublic,
        format: deckState.editableFields.unsaved.format,
        name: deckState.editableFields.unsaved.name,
        totalCardsBySerial: deckState.editableFields.unsaved.totalCardsBySerial,
        totalCardsByVariant: deckState.editableFields.unsaved.totalCardsByVariant,
        elements: deckState.editableFields.unsaved.elements,
        element: deckState.editableFields.unsaved.elements.join("/"),
        isComplete: isValidDeck,
        serials: Object.keys(deckState.editableFields.unsaved.totalCardsBySerial) || [],
        profileVariantId: profileVariantId,
        notes: deckState.editableFields.unsaved.notes ?? null,
        customTags: deckState.editableFields.unsaved.customTags ?? [],

        // Tournament
        tournamentId: deckState.nonEditableFields.tournamentId ?? "",
        tournamentName: deckState.nonEditableFields.tournamentName ?? "",
        playerName: deckState.editableFields.unsaved.playerName ?? "",
        isTournamentDeck: deckState.nonEditableFields.isTournamentDeck ?? false,
        rank: deckState.editableFields.unsaved.rank ?? "",
        needsArchetypeProcessing: deckState.nonEditableFields.needsArchetypeProcessing ?? false
    }

    if (includeNonEditableFields) {
        deck.views = deckState.nonEditableFields.views ?? 0;
    }

    return deck;
}